import React from "react";
import ProfitStatCard from "../components/ProfitStatCard";
import { ProfitInfoIcon } from "../components/ProfitIcons";
import {
  formatProfitCurrency,
  formatProfitCurrencyCompact,
  monthlyPerformance,
  profitMerchants,
  profitPortalMeta,
  profitRevenueKpis,
  profitRevenueModelText,
  renderProfitMeta,
} from "../data/profitData";

export default function ProfitRevenuePage() {
  const sortedMerchants = profitMerchants.slice().sort(function sortByShare(a, b) {
    return b.share - a.share;
  });

  return (
    <div className="profit-page">
      <div className="profit-page-header">
        <div className="profit-page-title">Revenue</div>
        <div className="profit-page-subtitle">
          Earnings from MDR spread · {profitPortalMeta.companyName}
        </div>
      </div>

      <div className="profit-alert profit-alert-info">
        <ProfitInfoIcon />
        <div>
          <strong>Revenue Share Model:</strong> {profitRevenueModelText}
        </div>
      </div>

      <div className="profit-kpi-grid">
        {profitRevenueKpis.map(function renderRevenueKpi(kpi) {
          return (
            <ProfitStatCard
              key={kpi.label}
              stripeClassName={kpi.stripeClassName}
              label={kpi.label}
              value={kpi.value}
            >
              {renderProfitMeta(kpi)}
            </ProfitStatCard>
          );
        })}
      </div>

      <div className="profit-card">
        <div className="profit-card-header">
          <div>
            <div className="profit-card-title">Monthly Performance</div>
            <div className="profit-card-subtitle">Revenue generated per month</div>
          </div>
        </div>
        <div className="profit-month-grid">
          {monthlyPerformance.map(function renderMonth(item) {
            return (
              <div className="profit-month-card" key={item.month}>
                <div className="profit-month-label">{item.month}</div>
                <div className="profit-month-value">{formatProfitCurrency(item.revenue)}</div>
                <div className="profit-month-subtitle">
                  Your share: {formatProfitCurrency(item.share)}
                </div>
                <div className="profit-progress">
                  <div className="profit-progress-fill" style={{ width: item.width }} />
                </div>
              </div>
            );
          })}
        </div>
      </div>

      <div className="profit-card profit-card-table profit-margin-top">
        <div className="profit-card-table-header">Revenue by Merchant</div>
        <div className="profit-table-wrap">
          <table className="profit-table">
            <thead>
              <tr>
                <th>Merchant</th>
                <th>Volume (SGD)</th>
                <th>Txns</th>
                <th>Base MDR</th>
                <th>Final MDR</th>
                <th>Spread</th>
                <th>Total Revenue</th>
                <th>Your Share (80%)</th>
              </tr>
            </thead>
            <tbody>
              {sortedMerchants.map(function renderMerchant(merchant) {
                return (
                  <tr key={merchant.id}>
                    <td className="profit-table-strong">{merchant.name}</td>
                    <td className="profit-mono">
                      {formatProfitCurrencyCompact(merchant.volume)}
                    </td>
                    <td>{merchant.txns.toLocaleString()}</td>
                    <td className="profit-mono">{merchant.baseMDR.toFixed(2)}%</td>
                    <td className="profit-mono">{merchant.finalMDR.toFixed(2)}%</td>
                    <td>
                      <span className="profit-badge profit-badge-blue">
                        {merchant.spread.toFixed(2)}%
                      </span>
                    </td>
                    <td className="profit-mono">SGD {merchant.revenue.toFixed(2)}</td>
                    <td className="profit-mono profit-positive">
                      SGD {merchant.share.toFixed(2)}
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
}
